import { useContext, useEffect, useLayoutEffect } from 'react'
import { InputField } from '../inputs/InputField'
import { useForm } from 'react-hook-form'
import { inputCurpRule, inputRequiredRule } from '../../helpers/form.helper'
import { Button, Typography } from '@mui/material'
import { AmbientestModuleContext } from '../../context/AmbientestModuleContext'
import { useNavigate } from 'react-router-dom'
import AppSteps from '../navigation/AppSteps'
import matchHelper from '../../helpers/match.helper'

interface FormPlainEnviromentCurpProps {
    description: string
}

export default function FormPlainEnviromentCurp({ description }: Readonly<FormPlainEnviromentCurpProps>) {
    const { control, formState, handleSubmit } = useForm()
    const context = useContext(AmbientestModuleContext)
    const navigate = useNavigate()

    function onSubmitCurp(data: any) {
        context?.validateCurp(data.curp)
    }

    useEffect(() => {
        if (context?.userData) {
            navigate(`${context.path}/datos`)
        }
    }, [context?.userData])

    useLayoutEffect(() => {
        context?.clearContext()
    }, [])

    return (<div>
        <AppSteps steps={context?.steps || []} actualStep={1} />
        <div className='form-contain-row'>
            <Typography component={'div'} variant='body1' sx={{ textAlign: 'center' }}>{description}</Typography>
        </div>
        <div className='form-contain-row'>
            <Typography component={'div'} variant='body1' sx={{ textAlign: 'center' }}>Para comenzar, ingresa tu CURP:</Typography>
        </div>
        <form
            className="form-contain business"
            onSubmit={handleSubmit(onSubmitCurp)}
            autoComplete="off"
        >
            <div className='form-contain-row'>
                <div></div>
                <div>
                    <InputField
                        controller={{
                            name: "curp",
                            control: control,
                            defaultValue: '',
                            rules: { 
                                ...inputRequiredRule,
                                ...inputCurpRule
                             }
                        }}
                        inputProps={{
                            maxLength: 18,
                            style: { textTransform: "uppercase" }
                        }}
                        errors={formState.errors}
                        label="Curp*"
                        autoFocus
                    />
                </div>
                <div></div>
            </div>
            <div className="form-contain-row">
                <div></div>
                <Button
                    type='submit'
                    variant='outlined'
                    className='app-btn-color'
                    sx={{ marginTop: '1.5rem' }}
                    fullWidth
                >
                    Validar
                </Button>
                <div></div>
            </div>
        </form>
    </div>)
}
